exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manage-import .tag[data-v-71d6088c]{margin:5px}", ""]);

// exports
